import React from 'react';
import { Link } from 'react-router-dom';

const GameCard = ({ game }) => {
  return (
    <Link to={`/${game.id}`} className="game-card">
      <div className="game-icon">{game.icon}</div>
      <div className="game-title">{game.title}</div>
      <div className="game-description">{game.description}</div>
    </Link>
  );
};

export default GameCard;